var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultBoy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EAECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9606 1.58059C41.1141 18.5195 26.7431 32 9.59999 32H0C0 14.3269 14.3269 0 32 0C35.4777 0 38.8257 0.554752 41.9606 1.58059Z",
    fill: "#2C374B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 14.3269 49.6731 0 32 0C28.5224 0 25.1743 0.554751 22.0394 1.58059C22.8859 18.5195 37.2569 32 54.4 32H64Z",
    fill: "#2C374B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48.0952H40C40 44.7289 37.1949 42 33.8286 42H32V48.0952Z",
    fill: "#313D53"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48.0952H24C24 44.7289 26.8051 42 30.1714 42H32V48.0952Z",
    fill: "#313D53"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBoy);
export default __webpack_public_path__ + "static/media/default_boy.539e85bf8e724d134145fc410a0cca71.svg";
export { ForwardRef as ReactComponent };